var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRight, ChevronLeft } from 'pcln-icons';
import { ARROW_SIZES } from './Arrow.styled';
import { Relative } from '../Relative';
import { Button } from '../Button';
const { bool, string, func } = PropTypes;
export const arrowPropTypes = {
    isLeft: bool,
    arrowButtonVariation: string,
    size: string,
    leftArrowClick: func,
    rightArrowClick: func,
    leftDisabled: bool,
    rightDisabled: bool,
};
const Arrow = (_a) => {
    var { isLeft, arrowButtonVariation, size, leftArrowClick, rightArrowClick, leftDisabled, rightDisabled } = _a, props = __rest(_a, ["isLeft", "arrowButtonVariation", "size", "leftArrowClick", "rightArrowClick", "leftDisabled", "rightDisabled"]);
    const Icon = isLeft ? ChevronLeft : ChevronRight;
    const { buttonSize, iconSize } = ARROW_SIZES[size];
    return (React.createElement(Relative, { zIndex: 99 },
        React.createElement(Button, Object.assign({ p: 0, variation: arrowButtonVariation, onClick: isLeft ? leftArrowClick : rightArrowClick, height: buttonSize, width: buttonSize, boxShadowSize: 'md', disabled: isLeft ? leftDisabled : rightDisabled }, props),
            React.createElement(Icon, { size: iconSize, pl: isLeft ? 0 : 1, pr: isLeft ? 1 : 0 }))));
};
export { Arrow };
//# sourceMappingURL=Arrow.js.map